const JOB_KEY = 'bulkUploadJob';
const STATUS_KEY = 'bulkUploadJobStatus';

const canUseStorage = () => typeof window !== 'undefined' && window.localStorage;

export const getBulkUploadJob = () => {
  if (!canUseStorage()) return null;
  try {
    const raw = window.localStorage.getItem(JOB_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const setBulkUploadJob = (job) => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(JOB_KEY, JSON.stringify(job));
  } catch (error) {
    // ignore storage errors
  }
};

export const clearBulkUploadJob = () => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.removeItem(JOB_KEY);
    window.localStorage.removeItem(STATUS_KEY);
  } catch (error) {
    // ignore storage errors
  }
};

export const setBulkUploadStatus = (status) => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(STATUS_KEY, JSON.stringify(status || {}));
  } catch (error) {
    // ignore storage errors
  }
};

export const getBulkUploadStatus = () => {
  if (!canUseStorage()) return null;
  try {
    const raw = window.localStorage.getItem(STATUS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const isBulkUploadInProgress = () => {
  const status = getBulkUploadStatus();
  const job = getBulkUploadJob();
  if (!job || !status?.status) return false;
  return [
    'pending',
    'uploading',
    'processing',
    'splitting',
    'classifying',
    'parsing',
  ].includes(status.status);
};

export const emitBulkUploadJobStarted = (job) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('bulk-upload-job-started', { detail: job }));
};
